<div class="delivery-area-header">
  <h3>Delivery Area</h3>

  <div class="delivery-area-sub-header">
    <div class="delivery-area-header-toggle-container">
      <div class="toggle-row">
        <mat-slide-toggle [(ngModel)]="extendedDeliveryAreaEnabled" (change)="toggleExtendedDeliveryArea()">
          Extended Delivery Area
        </mat-slide-toggle>

        <mat-slide-toggle [(ngModel)]="editModeEnabled" (change)="onEditModeToggle()"> Edit Mode </mat-slide-toggle>

        <mat-slide-toggle [(ngModel)]="zipcodeOverlayEnabled" (change)="toggleZipCodeOverlay()">
          Zip Code Overlay
        </mat-slide-toggle>

        @if (this.zipcodeOverlayEnabled) {
          <mat-slide-toggle [(ngModel)]="zipcodeLabelsEnabled" (change)="toggleZipCodeLabels()">
            Zip Code Labels
          </mat-slide-toggle>
        }
      </div>
      <div class="toggle-row">
        <mat-slide-toggle [(ngModel)]="showMultipleDeliveryAreasEnabled" (change)="toggleOtherStoreDeliveryAreas()">
          Show Multiple Delivery Areas
        </mat-slide-toggle>
        <multi-facility-selection
          [style.visibility]="showMultipleDeliveryAreasEnabled ? 'visible' : 'hidden'"
          (storesSelected)="renderSelectedStorePolygons($event)"></multi-facility-selection>
      </div>
    </div>

    <div class="delivery-area-header-legend-container">
      <div>
        <div>Standard:</div>
        <div class="legend-color standard-color"></div>
      </div>

      @if (this.extendedDeliveryAreaEnabled) {
        <div>
          <div>Extended:</div>
          <div class="legend-color extended-color"></div>
        </div>
      }

      @if (hasAnyMovPolygons()) {
        <div>
          <div>MOV:</div>
          <div class="legend-color mov-color"></div>
        </div>
      }
    </div>
  </div>
</div>

<mat-accordion>
  <mat-expansion-panel #panel="matExpansionPanel">
    <mat-expansion-panel-header>
      <mat-panel-title> How to use </mat-panel-title>
    </mat-expansion-panel-header>
    <p>
      The map shows two color-coded zones that display where we deliver - one for standard deliveries and another for
      extended range deliveries.
    </p>
    <h4>Customizing Delivery Zones:</h4>
    <ul>
      <li><b>Adding a new point:</b> click and drag any center point to create a new corner</li>
      <li><b>Removing a point:</b> Right-click on any corner to delete it</li>
      <li><b>Moving the whole area:</b> Click anywhere inside the colored area and drag it where you'd like</li>
    </ul>

    You can adjust these zones anytime to match your actual delivery coverage areas. To save your changes, click the
    "Save Change" button below.
  </mat-expansion-panel>
</mat-accordion>

<div class="delivery-map-wrapper">
  <div #map class="delivery-map"></div>
  <div class="button-container">
    @if (this.showResetPolygon) {
      <button style="margin-right: 1rem" mat-flat-button color="accent" (click)="resetPolygonAroundFacility()">
        Reset Polygons
      </button>
    }
    <button mat-flat-button color="accent" [disabled]="saveDisabled" (click)="saveDeliveryData()">Save Change</button>
  </div>
</div>
